function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Skeleton, Image, Space, Statistic, Row as AntRow, Col as AntCol, Card, Button } from "antd";
import { Container, Row, Col } from "react-bootstrap";
import { AwardFill, PeopleFill } from "react-bootstrap-icons";
import Common from "./includes/Common";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Meta = Card.Meta;
var ContestView = function ContestView(_ref) {
  var contest_id = _ref.contest_id;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    contest = _useState2[0],
    setContest = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isDataLoading = _useState4[0],
    setIsDataLoading = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    errorMessage = _useState6[0],
    setErrorMessage = _useState6[1];
  useEffect(function () {
    setIsDataLoading(true);
    axios.get(Common.baseApiUrl + "getcontest/" + contest_id).then(function (response) {
      if (response.data.status == 200) {
        setContest(response.data.contest);
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setErrorMessage("Une erreur est survenue");
    })["finally"](function () {
      setIsDataLoading(false);
    });
  }, []);
  return /*#__PURE__*/_jsx(Container, {
    children: isDataLoading ? /*#__PURE__*/_jsx(Skeleton, {
      active: true
    }) : /*#__PURE__*/_jsx("div", {
      children: contest && /*#__PURE__*/_jsx(AntRow, {
        gutter: 16,
        children: contest.contest_milestones.map(function (m) {
          return /*#__PURE__*/_jsx(AntCol, {
            span: 8,
            children: /*#__PURE__*/_jsxs(Card, {
              hoverable: true,
              style: {
                width: 240,
                marginBottom: "12px"
              },
              cover: /*#__PURE__*/_jsx("img", {
                src: m.cover_url
              }),
              actions: [/*#__PURE__*/_jsx(Button, {
                type: "primary",
                icon: /*#__PURE__*/_jsx(AwardFill, {}),
                onClick: function onClick() {
                  setSelectedMilestone(m);
                  setShowContestReport(true);
                },
                children: /*#__PURE__*/_jsx("b", {
                  children: "Voter maintenant"
                })
              })],
              children: [/*#__PURE__*/_jsx(Meta, {
                title: m.label,
                description: /*#__PURE__*/_jsx("p", {
                  children: m.description
                })
              }), /*#__PURE__*/_jsx("div", {})]
            })
          }, m.id);
        })
      })
    })
  });
};
export default ContestView;